import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-seguridad-creacion-perfil',
  templateUrl: './seguridad-creacion-perfil.component.html',
  styleUrls: ['./seguridad-creacion-perfil.component.scss']
})
export class SeguridadCreacionPerfilComponent implements OnInit {
  @Output() selecttab = new EventEmitter<String>();

  constructor() { }

  ngOnInit(): void {
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }

}
